module.exports = __webpack_public_path__ + "img/cta-bg-mobile.ecafebc1.png";